module.exports = __webpack_public_path__ + "static/media/nonImsfooter.6b93c42c.svg";